import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_INSURANCES_REQUEST, fetchInsurancesSuccess, fetchInsurancesFailure,
  CREATE_INSURANCE_REQUEST, createInsuranceSuccess, createInsuranceFailure,
  UPDATE_INSURANCE_REQUEST, updateInsuranceSuccess, updateInsuranceFailure,
  DELETE_INSURANCE_REQUEST, deleteInsuranceSuccess, deleteInsuranceFailure
} from '../actions/insuranceActions';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = getBaseUrl();
const authToken = localStorage.getItem('authToken');
const getAuthToken = () => localStorage.getItem('authToken');

const createConfig = () => ({
  headers: { 'Authorization': `Bearer ${authToken}` }
});

function* fetchInsurances(action) {
  try {
    const token = getAuthToken();
    const { projectId, page = 1, limit = 2, search = '', group = '' } = action.payload || {};

    console.log("Fetching insurance data with payload: ", { projectId, page, limit, search, group });

    const baseUrl = getBaseUrl();

    const response = yield call(
      axios.get,
      `${baseUrl}/${projectId}/insurance`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search, group },
      }
    );

    // Assuming response structure includes `data` and `meta`
    yield put(fetchInsurancesSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || "An unknown error occurred";
    console.error("Error fetching insurance data: ", errorMessage);
    yield put(fetchInsurancesFailure(errorMessage));
  }
}


function* createInsurance(action) {
  try {
    const response = yield call(axios.post, `${API_BASE_URL}/${action.payload.projectId}/insurance`, action.payload.data, createConfig());
    yield put(createInsuranceSuccess(response.data));
  } catch (error) {
    yield put(createInsuranceFailure(error.message));
  }
}

function* updateInsurance(action) {
  try {
    const { id, data,projectId} = action.payload;
    const response = yield call(axios.put, `${API_BASE_URL}/${projectId}/insurance/${id}`, data, createConfig());
    yield put(updateInsuranceSuccess(response.data));
  } catch (error) {
    yield put(updateInsuranceFailure(error.message));
  }
}

function* deleteInsurance(action) {
  try {
    // console.log("action : ",action.payload)
    const { id,projectId } = action.payload;
    yield call(axios.delete, `${API_BASE_URL}/${projectId}/insurance/${id}`, createConfig());
    yield put(deleteInsuranceSuccess(id));
  } catch (error) {
    yield put(deleteInsuranceFailure(error.message));
  }
}

export default function* insuranceSaga() {
  yield takeLatest(FETCH_INSURANCES_REQUEST, fetchInsurances);
  yield takeLatest(CREATE_INSURANCE_REQUEST, createInsurance);
  yield takeLatest(UPDATE_INSURANCE_REQUEST, updateInsurance);
  yield takeLatest(DELETE_INSURANCE_REQUEST, deleteInsurance);
}
